import { render } from "./sign-in.svg?vue&type=template&id=168daf44"
const script = {}
script.render = render

export default script